import React from 'react'
import { Button, Divider, Typography } from 'antd'
import { CalendarOutlined, MessageOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import { format } from 'date-fns'

import { EXTEND_TRIAL_GRANTED_DAYS } from '@vacationtracker/shared/constants/survey'
import { openSupportChat } from '../../util/open-support-chat'
import IntlMessages from '../../util/IntlMessages'

const CALENDLY_URL = 'https://calendly.com/vacation-tracker/vacation-tracker-setup'

interface ITrialSurveySuccessProps {
  trialEnd: string
  onClose: () => void
}

export function TrialSurveySuccess({ trialEnd, onClose }: ITrialSurveySuccessProps): JSX.Element {
  const { formatMessage } = useIntl()
  const dateStr = format(new Date(trialEnd), 'MMMM d, yyyy')

  return (
    <div style={{ textAlign: 'center', padding: '8px 8px 8px' }}>
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'rgba(124, 58, 237, 0.18)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        <CalendarOutlined style={{ fontSize: 28, color: '#7c3aed' }} />
      </div>

      <div style={{ marginBottom: 12 }}>
        <span
          style={{
            display: 'inline-block',
            padding: '2px 12px',
            borderRadius: 999,
            background: 'rgba(124, 58, 237, 0.2)',
            color: '#a78bfa',
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          {formatMessage({ id: 'survey.extendTrial.success.daysAdded' }, { days: EXTEND_TRIAL_GRANTED_DAYS })}
        </span>
      </div>

      <Typography.Title level={3} style={{ marginTop: 0, marginBottom: 8 }}>
        {formatMessage({ id: 'survey.extendTrial.success.title' })}
      </Typography.Title>

      <Typography.Paragraph type="secondary" style={{ marginBottom: 24 }}>
        <IntlMessages id="survey.extendTrial.success.subtitle" values={{ date: dateStr, b: (...chunks) => <strong>{chunks}</strong> }} />
      </Typography.Paragraph>

      <Button type="primary" size="large" block icon={<CalendarOutlined />} href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
        {formatMessage({ id: 'survey.extendTrial.success.calendlyCta' })}
      </Button>
      <Typography.Paragraph type="secondary" style={{ marginTop: 8, marginBottom: 0, fontSize: 13 }}>
        {formatMessage({ id: 'survey.extendTrial.success.calendlyHint' })}
      </Typography.Paragraph>

      <Divider plain style={{ margin: '16px 0' }}>
        {formatMessage({ id: 'survey.extendTrial.success.or' })}
      </Divider>

      <Button size="large" block icon={<MessageOutlined />} onClick={() => openSupportChat()}>
        {formatMessage({ id: 'survey.extendTrial.success.chatCta' })}
      </Button>

      <Button type="link" onClick={onClose} style={{ marginTop: 16 }}>
        {formatMessage({ id: 'survey.extendTrial.success.backToDashboard' })}
      </Button>
    </div>
  )
}
